/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import Turnstile from 'react-turnstile';
import useContactData from '../hooks/useContactData';
import useLegalUrl from '../hooks/useLegalUrl';
import { isRutValid } from '../../utils'

const FormContact = (props) => {

    const [values, setValues] = useState({
        full_name: "",
        email: "",
        rut: "",
        phone_number: "",
        city: "",
        service: "Kinto Share",
        message: "",
        section_delivered: "Reservar",
    });
    const [ turnstileToken, setTurnstileToken ] = useState(false);

    const { contactData } = useContactData();
    const { legal_url } = useLegalUrl();

    const sitekey = document.getElementById("recaptcha_sitekey").getAttribute('value');

    const handleOnFormChange = (e) => {
        if (e.target.value) {
            e.target.classList.add('-interacted');
        }
        else {
            e.target.classList.remove('-interacted');
        }
    }

    const handleInput = (e) => {
        let inputName = e.target.name;
        let value = e.target.value;
        setValues(prevState => ({
            ...prevState,
            [inputName]: value,
        }))
    }

    const postForm = async (e) => {
        e.preventDefault();
        let labelError = document.querySelector(".form__label-error");
        let inputError = document.getElementById("contact-form-rut");
        if (!isRutValid(values.rut)) {
            labelError.style.display = "flex";
            inputError.style.borderColor = "#ec0000";
        } else {
            inputError.style.borderColor = "#738184";
            labelError.style.display = "none";
            const response = await axios.post(e.target.getAttribute('action'), values, {
                headers: {
                    'X-CSRFToken': document.querySelector('meta[name="csrf-token"]').content
                }
            });
            props.contactFormSended(true)
        };
    }

    const handleTokenSumit = (token) => {
        fetch("/recaptcha/", {
            method: "POST",
            body: JSON.stringify({ token: token }),
            headers: {
                "Content-Type": "application/json",
                'X-CSRFToken': document.querySelector('meta[name ="csrf-token"]').content
            },
        })
        .then(response => response.json())
        .then((data) => {
            if (data.success){
                setTurnstileToken(true);
            }
        })
        .catch((error) => {
            console.log("ERROR", error);
        });
    }


    return (
        <form
            action='/api/kinto/forms/contact/'
            onSubmit={postForm}
            method='post'
            className='form'
            data-form-type='cotizador'
            onChange={handleOnFormChange}>
            <div className='form__input-wrapper'>
                <input
                    type='text'
                    name='full_name'
                    value={values.full_name}
                    onChange={handleInput}
                    id='contact-form-name'
                    className='form__input'
                    required></input>
                <label htmlFor='contact-form-name' className='form__label'>
                    Nombre y Apellido (*)
                </label>
            </div>
            <aside className='form__input-aside'>
                <div className='form__input'>
                    <input
                        type='email'
                        name='email'
                        value={values.email}
                        onChange={handleInput}
                        id='contact-form-email'
                        className='form__input'
                        required></input>
                    <label htmlFor='contact-form-email' className='form__label'>
                        Email (*)
                    </label>
                </div>
                <div className='form__input'>
                    <input
                        type='text'
                        name='rut'
                        value={values.rut}
                        onChange={handleInput}
                        id='contact-form-rut'
                        className='form__input'
                        required></input>
                    <label htmlFor='contact-form-rut' className='form__label'>
                        RUT (*)
                    </label>
                    <label
                        htmlFor='contact-form-rut'
                        className='form__label-error'>
                        RUT Invalido
                    </label>
                </div>
            </aside>
            <aside className='form__input-aside'>
                <div className='form__input'>
                    <input
                        type='text'
                        name='phone_number'
                        value={values.phone_number}
                        onChange={handleInput}
                        id='contact-form-phone'
                        className='form__input'
                        required></input>
                    <label htmlFor='contact-form-phone' className='form__label'>
                        Teléfono (*)
                    </label>
                </div>
                <div className='form__input'>
                    <input
                        type='text'
                        name='city'
                        value={values.city}
                        onChange={handleInput}
                        id='contact-form-city'
                        className='form__input'
                        required></input>
                    <label htmlFor='contact-form-city' className='form__label'>
                        Ciudad (*)
                    </label>
                </div>
            </aside>
            <div className='form__input-wrapper --select'>
                <select className="form__input" 
                    name="service"
                    value={values.service}
                    id="contact-form-service"
                    onChange={handleInput} 
                    hidden
                    required>
                    <option value=""></option>
                    <option value="Kinto One Personal">Kinto One Personal</option>
                    <option value="Kinto Share">Kinto Share</option>
                </select>
                <label htmlFor='contact-form-service' className='form__label--hidden'>
                    Seleccionar Servicio (*)
                </label>
            </div>
            <div className='form__input-wrapper textarea'>
                <textarea
                    type='text'
                    name='message'
                    value={values.message}
                    onChange={handleInput}
                    id='contact-form-message'
                    className='form__input'
                    required></textarea>
                <label htmlFor='contact-form-message' className='form__label textarea'>
                    Comentario (*)
                </label>
            </div>

            <div className='form__row'>
                <Turnstile
                    theme="light"
                    sitekey={sitekey}
                    onVerify={(token) => {
                        handleTokenSumit(token);
                    }}
                />
            </div>

            <div className='form__row'>
                <aside className='form__row-submit'>
                    <input
                        type='hidden'
                        name='cotizador_data'
                        value={JSON.stringify(contactData)}
                    />
                    <input
                        type='hidden'
                        name='section_delivered'
                        value='Reservar'
                        data-pagetitle='Reservar'
                        id='contact-form-section_delivered'
                        className='form__input'
                    />
                    
                    <button
                        type='submit'
                        className='button button--navy button--small'
                        onClick={()=> {
                            dataLayer.push({
                                'event': 'trackEvent',
                                'eventCategory': 'cotizar_share',
                                'eventAction': 'cta',
                                'eventLabel': 'enviar'
                            });
                        }}
                        disabled={!turnstileToken}
                        >
                        Enviar
                    </button>
                </aside>
            </div>

            <small className='form__disclaimer'>(*) Campo obligatorio.</small>
            <small className='form__disclaimer'>
                Al clickear el botón ENVIAR, estarás certificando que eres mayor
                de 18 años y que has leído y estás de acuerdo con los{" "}
                <a href={legal_url} target="_blank" rel="noopener noreferrer">
                    Términos &amp; Condiciones
                </a>
                .
            </small>
        </form>
    );
}

export default FormContact;